import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    AspectRatioStateDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    state: {
        ...StyleSheet.absoluteFill,
        justifyContent: "center",
        alignItems: "center"
    },
    stateText: {
        alignItems: "center",
        maxWidth: "100%",
        minWidth: 0
    },
    stateLine: {
        textAlign: "center"
    }
});

export const useStyles = ({
    isIconOnly,
    spaces
}: AspectRatioStateDynamicStyleType) => {
    const styles = {
        stateText: {
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>,
        state: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(!isIconOnly) {
        styles.state.padding = spaces.spacingMd;
    }

    return styles;
};
export default stylesheet;
